export default __webpack_public_path__ + "locales/ja-JP/DataReassignmentDialog.json?hash=6b6cff24db581c57c26e42a7791ccfa5";